export default __webpack_public_path__ + "static/media/cars-parked-house.e7196d03.jpg";